import { useEffect } from 'react'
import { Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { useOrderModel } from '../orderModel'
import { IOrderDetail } from '../orderService'
import useNavModel from '@/model/navModel'

export function DataTable() {
    const { dataSource, selectedRowKeys, pgCfg, loading, loadData, setSelectedRowKeys } = useOrderModel()

    useEffect(() => {
        loadData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const { addNav, findNav, switchNavState } = useNavModel(() => [])

    const columns: ColumnsType<IOrderDetail> = [
        {
            title: '序号',
            width: 50,
            align: 'center',
            render: (t, r, i) => i + 1,
        },
        {
            title: '操作',
            width: 60,
            align: 'center',
            render: (text, record, index) => (
                <span style={{ color: '#4165E3', cursor: 'pointer' }} onClick={() => detialLook(record)}>
                    详情
                </span>
            ),
        },
        {
            title: '车辆牌照',
            width: 120,
            align: 'center',
            dataIndex: 'customerVehicleCode',
        },
        {
            title: '车辆品牌',
            width: 250,
            align: 'center',
            dataIndex: 'customerVehicleBrand',
        },
        {
            title: '单据数量',
            width: 250,
            align: 'center',
            dataIndex: 'orderNum',
        },
    ]
    const detialLook = (record: any) => {
        let supplierEditKey = '2-1-1'
        let isFindNav = findNav(supplierEditKey)
        if (!isFindNav) {
            addNav(supplierEditKey, { id: record?.customerVehicleCode, mode: 'look' })
        } else {
            switchNavState(supplierEditKey, { id: record?.customerVehicleCode, mode: 'look' })
        }
    }

    //点击行选高亮
    const onRow = (record: IOrderDetail) => {
        let findObj = selectedRowKeys.find((item) => item.customerVehicleCode === record.customerVehicleCode)
        if (findObj) {
            let newSelectedRowKeys = selectedRowKeys.filter((item) => item.customerVehicleCode !== record.customerVehicleCode)
            setSelectedRowKeys(newSelectedRowKeys)
        } else {
            setSelectedRowKeys((origin) => [...origin, record])
        }
    }

    return (
        <Table
            rowKey={(record) => record?.customerVehicleCode as string}
            loading={loading}
            rowSelection={{
                //全部选中时 (存row[])
                onSelectAll: (selected, _selectedRows, changeRows) => {
                    selected
                        ? setSelectedRowKeys((origin) => [...origin, ...changeRows])
                        : setSelectedRowKeys((origin) => {
                              let changeRowId = changeRows.map((item) => item.customerVehicleCode)
                              return origin.filter((item) => changeRowId.indexOf(item.customerVehicleCode) < 0)
                          })
                },
                onSelect: (record) => onRow(record),
                selectedRowKeys: selectedRowKeys.map((item) => item.customerVehicleCode as string),
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ['bottomRight'],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                },
                showSizeChanger: true,
            }}
            bordered
            onRow={(record) => ({
                onClick: () => onRow(record),
                onContextMenu: (e) => {
                    e.preventDefault()
                    setSelectedRowKeys([record])
                },
            })}
        />
    )
}
